export const SCHEDULES_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'schedule_booking',
  'public_agent_module_permission',
  'group_module_permission',
  'schedule_skeleton',
  'schedule_planning',
]
